import { useDraggable } from '@dnd-kit/core';
/* eslint-disable react/prop-types */ // TODO: add props

const Draggable = ({ id, children, data, disabled, className }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data,
    disabled,
  });

  const transformStyle = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return (
    <span
      className={className}
      ref={setNodeRef}
      style={transformStyle}
      {...listeners}
      {...attributes}
    >
      {children}
    </span>
  );
};

export default Draggable;
